<template>
  <div id="camera-container" class="flex justify-center max-w-7xl min-h-360 mx-auto">
    <div class="bg-vice-light-grey w-full rounded-l-lg overflow-hidden">
      <slot name="camera-preview"></slot>
    </div>
    <div class="bg-vice-light-grey flex items-center justify-center rounded-r-lg w-full">
      <div class="text-black text-center px-6 py-4 preview-left">
        <p class="mb-4">
          <strong>Please make sure you are visible to your students.</strong>
          Consider background and lighting, and how you position yourself in front of the camera.
        </p>
        <div class="flex">
          <ScreenPreviewIcon class="w-full h-36"></ScreenPreviewIcon>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ScreenPreviewIcon from '@/Components/Icons/ScreenPreviewIcon.vue';

export default {
  components: {
    ScreenPreviewIcon,
  },
};
</script>
